export function addBusinessDays(startDate, n, holidays) {
  const result = new Date(startDate);
  let remaining = n;
  while (remaining > 0) {
    result.setUTCDate(result.getUTCDate() + 1);
    const day = result.getUTCDay();
    const isoDate = result.toISOString().slice(0, 10);
    const isWeekend = day === 0 || day === 6;
    const isHoliday = holidays.includes(isoDate);
    if (!isWeekend && !isHoliday) {
      remaining -= 1;
    }
  }
  return result;
}

export function renderTemplate(template, values) {
  return template.replace(/\{(\w+)\}/g, (match, key) => {
    return key in values ? values[key] : match;
  });
}

export function lookupEstimate(data, countryCode) {
  if (!countryCode) return null;
  if (!data || !data.estimates) return null;
  const estimate = data.estimates[countryCode];
  return estimate || null;
}

export const PT_HOLIDAYS = [
  '2026-04-25',
  '2026-05-01',
  '2026-06-10',
  '2026-06-11',
  '2026-08-15',
  '2026-10-05',
  '2026-11-01',
  '2026-12-01',
  '2026-12-08',
  '2026-12-25',
];

function formatDate(date, locale) {
  try {
    return new Intl.DateTimeFormat(locale, { month: 'short', day: 'numeric' }).format(date);
  } catch {
    return new Intl.DateTimeFormat('en', { month: 'short', day: 'numeric' }).format(date);
  }
}

function countryNameFrom(countryCode, locale) {
  try {
    return new Intl.DisplayNames([locale], { type: 'region' }).of(countryCode);
  } catch {
    return countryCode;
  }
}

async function hydrate(element) {
  const countryCode = element.dataset.country;
  const locale = element.dataset.locale || 'en';
  const template = element.dataset.template;
  const textEl = element.querySelector('.delivery-estimate__text');
  if (!textEl || !template) return;

  try {
    const assetUrl = element.dataset.dataUrl;
    const response = await fetch(assetUrl, { cache: 'default' });
    if (!response.ok) return;

    const data = await response.json();
    const estimate = lookupEstimate(data, countryCode);
    if (!estimate) return;

    const today = new Date();
    const minDate = addBusinessDays(today, estimate.min, PT_HOLIDAYS);
    const maxDate = addBusinessDays(today, estimate.max, PT_HOLIDAYS);

    const rendered = renderTemplate(template, {
      country_name: countryNameFrom(countryCode, locale),
      date_min: formatDate(minDate, locale),
      date_max: formatDate(maxDate, locale),
    });
    textEl.textContent = rendered;
  } catch {
    // Silent failure — fallback copy already rendered server-side
  }
}

if (typeof document !== 'undefined') {
  const run = () => {
    document.querySelectorAll('.delivery-estimate').forEach(hydrate);
  };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
}
